import handleEventName from './event-name-handler';

/**
 * Функция-издатель
 */
function publish (evt, evtData) {
  const self = this;
  const eventsArr = handleEventName(evt);

  eventsArr.forEach(evtName => {
    self.logger.addListener(evtName);

    try {
      self._selectEvent(evtName).fire(evtData);
    }
    catch (err) {
      console.warn(err);
    }
    finally {
      return;
    }
  });

  return;
}

export default publish;
